import { render, staticRenderFns } from "./TurnChecker.vue?vue&type=template&id=5ba78cb4&lang=pug&"
import script from "./TurnChecker.vue?vue&type=script&lang=js&"
export * from "./TurnChecker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports